import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/betShopManagement/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/betShopManagement/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from devConfig
                },
            ],
        };

        // Left panel configuration
        const left = {
            scroll: true,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Seguridad Cambios') }, // Label for the toolbar
                    ],
                },
                Table, // Including the Table component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Permission check for accessing the security changes menu
        if (!devConfig.getPermAction('betShopManagementConfigurationSecurityChangesMenu', 'Menu')) {
            this.show('./betShopManagement.configuration.qrgoogle'); // Redirect if permission is denied
        } else {
            return {
                id: 'a5',
                type: 'clean',
                view: 'form', // Main view type is a form
                scroll: 'y', // Enable vertical scrolling
                rows: [
                    {
                        responsive: 'a5',
                        type: 'wide',
                        cols: [left], // Include the left panel
                    },
                ],
            };
        }
    }
}

// FILE DOCUMENTED
